<template>
	<div style="min-height: 720px;padding: 20px 20px 20px 0;">
		<el-button
		class="keepBtn"
		size="medium"
		@click="newEquity()"
		>新建</el-button>

		<div v-loading="loading">
			<el-table
			:data="activityTable"
			:header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
			:cell-style="{ 'text-align': 'left' }"
			style="width: 100%; margin: 40px auto"
			>
			<el-table-column
				prop="sort"
				label="权益顺序"
				width="200"
			>
			</el-table-column>
			<el-table-column
				prop="name"
				label="权益名称"
			>
			</el-table-column>
			<el-table-column
				prop="status"
				label="权益状态"
			>
			<template  slot-scope="scope">
				{{ scope.row.status == 1 ? '启用':'禁用' }}
			</template>
			</el-table-column>
			<el-table-column
				prop="statsDate"
				label="权益图标"
			>
			<template slot-scope="scope">
				<img :src="scope.row.benefitEnableIconUrl" alt style="width: 50px;">
			</template>
			</el-table-column>
			<el-table-column  label="操作">
					<template  slot-scope="scope">
						<span @click="editEquity(scope.row)" style="cursor: pointer;color: #7B61FF;" >编辑</span>
						<span @click="getStatus(scope.row)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;" v-if="scope.row.status == 1 ">禁用</span>
						<span @click="getStatus(scope.row)" style="cursor: pointer;color: #7B61FF;margin-left: 20px;" v-else>启用</span>
					</template>
			</el-table-column>
			</el-table>
			<el-pagination
			style="text-align: right; margin: 25px"
			@size-change="handleSizeChange"
			background
			@current-change="handleCurrentChange"
			:page-sizes="[10, 20, 30, 50, 100, 500]"
			:page-size="formList.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalNum"
			:current-page="formList.current"
			></el-pagination>
		</div>

		<!-- 新建/编辑弹窗 -->
		<equityDialog 
		:openDialog="openDialog" 
		:editData="editData"
		v-if="openDialog"
		:isEdit="isEdit"
		@cancel="openDialog = false;"
		@saveData ="saveDialog"
		></equityDialog>

		
	</div>
</template>

<script>
import equityDialog from "../dialog/equityDialog";
import { getMemberBenefit,getStatus } from "@/api/brandCustom/brandMemberCenter";
export default {
name: '' ,
components: {
	equityDialog
},
props:{},
data() {
return {
	loading:false,
	activityTable:[],
	formList:{
		current:1,
		size:10,
	},
	totalNum:0,
	openDialog:false,//控制弹窗显示
	isEdit:false,//是否编辑
	editData:{},//编辑内容
}
},
computed: {},
created() {

},
mounted() {
	this.getConfig()
},
methods: {
	  //获取详情
		getConfig(){
				this.loading = true,
				getMemberBenefit(this.formList).then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.activityTable = res.data.records;
						this.totalNum = Number(res.data.total)
					}else{
						this.$message.error(res.message);
					}
				});
		},
		// 启用/禁用
		getStatus(item){
			let params ={
				id:item.id,
				type:item.status == 1?0:1
			}
			this.loading = true
			getStatus(params).then((res) => {
					this.loading = false;
					if (res.code == 1) {
						this.$message.success("修改状态成功！");
						this.getConfig()
					}else{
						this.$message.error(res.message);
					}
				});
		},
		//新建弹窗
		newEquity(){
			this.openDialog = true;
			this.isEdit = false;
		},
		//编辑弹窗
		editEquity(item){
			this.openDialog = true;
			this.editData = item;
			this.isEdit = true;
		},
		saveDialog(){
			this.openDialog = false;
			this.getConfig()
		},
		handleSizeChange(val) {
      this.formList.size = val;
      this.getConfig();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.getConfig();
    },
}
}
</script>
<style lang='scss' scoped>
  .keepBtn{
    border-radius: 4px;
    width: 72px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    color:#fff;
    background: #7B61FF;
    &:hover{
      opacity: 0.9;
    }
  }
</style>